import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useRUIIdsByImageId = (imageId: string | undefined, authorId: string | undefined, userId: string | undefined): string[] => {
  const RUIDb = useSelector((state: RootState) => state.relationUserImageDb);
  let ids: string[];
  
  if (authorId === userId) {
    ids = Object.keys(RUIDb.relationUserImages).filter(id => (RUIDb.relationUserImages[id].imageId === imageId));
  }
  else {
    ids = Object.keys(RUIDb.relationUserImages).filter(id => 
          (RUIDb.relationUserImages[id].userId === userId) && (RUIDb.relationUserImages[id].imageId === imageId));
  }

  return ids;
}

export default useRUIIdsByImageId;
